import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'rewards.hero.new.header',
    description: 'Promotional heading text',
    defaultMessage: `Sip More, Earn More`,
  },
  body: {
    id: 'rewards.hero.new.body',
    description: 'Promotional text',
    defaultMessage:
      'Become a Starbucks® Rewards member today and get rewarded for what you already love—and more!',
  },
});
